export default function buildGetWithdrawalReqs({
    apiEndpoint,
    apiTools
}) {
    return async function getWithdrawalReqs(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }withdrawal-reqs` 
        })
       
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
            'Authorization': 'salaTokken'
            },
            credentials: 'include',
        });
        return await res.json();
    }
}